// extracted by mini-css-extract-plugin
export default {"wrapper":"DataTable_wrapper__GILba","inputWrapper":"DataTable_inputWrapper__X6MUw","inputContainer":"DataTable_inputContainer__fulfh"};